export function dollarsToCents(value: number | null | undefined): number | null {
  return value != null && Number.isFinite(value) ? Math.round(value * 100) : null;
}

export function formatUsdCompact(value: number, options: { withSymbol?: boolean } = {}): string {
  const { withSymbol = true } = options;
  const prefix = withSymbol ? '$' : '';
  const abs = Math.abs(value);
  if (abs < 1000) return `${prefix}${Math.round(value)}`;
  if (abs < 1_000_000) return `${prefix}${trimZero(value / 1000)}k`;
  if (abs < 1_000_000_000) return `${prefix}${trimZero(value / 1_000_000)}M`;
  return `${prefix}${trimZero(value / 1_000_000_000)}B`;
}

function trimZero(n: number): string {
  const rounded = Math.round(n * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

export function parseUsdToCents(input: string): number | null {
  const cleaned = input.replace(/[^\d.]/g, '');
  if (cleaned === '') return 0;
  const dotIdx = cleaned.indexOf('.');
  const normalized =
    dotIdx === -1
      ? cleaned
      : cleaned.slice(0, dotIdx + 1) + cleaned.slice(dotIdx + 1).replace(/\./g, '');
  const num = Number.parseFloat(normalized);
  if (!Number.isFinite(num) || num < 0) return null;
  return Math.round(num * 100);
}
